import { AddOnFeature } from "../AddOns/components/add-on-feature";

export default function ForStartups() {
  return (
    <main className="mx-auto max-w-6xl px-2 py-20 md:px-5 md:py-12 sm:px-4 sm:py-8">
      <header className="mb-16 text-center md:mb-10 sm:mb-6">
        <h1 className="text-5xl font-semibold tracking-tight text-[#0C0C0C] md:text-3xl sm:text-2xl">
          For Startups — Building Schools That Lead the Future
        </h1>
        <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
          SooMuch.AI is your complete launch and growth partner. This is the kind of support we offer:
        </p>
      </header>

      <div className="flex flex-col gap-16 md:gap-10 sm:gap-8">
        <AddOnFeature
          title={"Company Secretary Support"}
          description={
            <>
              Guidance and assistance with company setup and administrative processes. Help with maintaining essential records, schedules, and compliance workflows.
            </>
          }
          imageAlt="Company Secretary Support"
          imageQuery="images/new-landing-page/startUp1.svg"
          cta=""
        />

        <AddOnFeature
          reverse
          title="Chartered Accountant Support"
          description={
            <>
              Financial planning, accounting system setup, ROI and cost optimization. Payroll, fee & pricing strategies, and investor-ready reporting.
            </>
          }
          imageAlt="Chartered Accountant Support"
          imageQuery="images/new-landing-page/startUp2.svg"
          cta=""
        />

        <AddOnFeature
          title="Brand Building & Expansion"
          description={
            <>
              <p>
                Crafting a strong school identity, mission, and vision. Marketing-ready brand assets: logo, website, brochures, prospectus. Scaling strategies to attract top-tier admissions without additional ad spend.
              </p>
            </>
          }
          imageAlt="Brand Building & Expansion"
          imageQuery="images/new-landing-page/startUp3.svg"
          cta=""
        />

        <AddOnFeature
          reverse
          title="Admissions Growth Partner"
          description={
            <>
              AI-powered admission funnels to maximize inquiries and conversions. Parent engagement strategies to build trust and advocacy. Referral and community programs that increase admissions organically. Tools and processes designed to double admissions in 3 years or generate up to ₹2.5 crore in revenue.
            </>
          }
          imageAlt="Admissions Growth Partner"
          imageQuery="images/new-landing-page/startUp4.svg"
          cta=""
        />
        <div className="h-0.5 bg-gray-400" />
        <div className="grid grid-cols-2 md:grid-cols-1 gap-y-4">
          <h3 className="text-[#0C0C0C] text-pretty text-4xl font-semibold tracking-tight md:text-3xl sm:text-2xl">
            Our Vision
          </h3>
          <div className="text-sm leading-6 text-[#4D4D4D] sm:text-xs sm:leading-5">
            With the SooMuch.Ai app, our vision is to ensure every school operates at par with global institutes without having to hire extra staff or spend additional money on advertising and marketing.
          </div>
          <h3 className="text-[#0C0C0C] text-pretty text-4xl font-semibold tracking-tight md:text-3xl sm:text-2xl">
            The Result
          </h3>
          <div className="text-sm leading-6 text-[#4D4D4D] sm:text-xs sm:leading-5">
            With SooMuch.Ai, your school launches efficiently, operates seamlessly, grows sustainably, and achieves measurable admissions success — all while keeping operations, finances, and branding world-class.
          </div>
        </div>
      </div>
    </main>
  )
}